import { heroStats } from '@/mocks/homeData';

export default function HeroSection() {
  const scrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-50 via-background-100 to-primary-50/30"></div>
      <div className="absolute top-0 right-0 w-full md:w-1/2 h-full opacity-20 md:opacity-30">
        <div className="absolute inset-0 bg-gradient-to-l from-primary-100/40 to-transparent"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 py-24 md:py-20">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1 text-xs font-semibold text-primary-600 bg-primary-100/70 rounded-full mb-4 whitespace-nowrap">
              电视剧大全 · 免费高清影视平台
            </span>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-tight">
              爱丫爱丫影院
              <br />
              <span className="text-primary-500">高清流畅 极速秒开</span>
            </h1>

            <p className="mt-4 text-lg text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0">
              爱丫爱丫影院是一个专注电视剧大全全集免费在线观看的平台，汇聚最新国产剧、韩剧全集等海量资源。每日更新超过200集高清内容，极速秒开不缓冲，让追剧成为纯粹的享受。
            </p>

            <p className="mt-3 text-base text-foreground-500 leading-relaxed max-w-xl mx-auto lg:mx-0">
              无论你偏爱古装传奇的恢弘气韵、都市情感的细腻笔触，还是悬疑探案的烧脑反转，这里都能找到属于你的那一部好剧。打开即看，无需注册，畅享丝滑观影体验。
            </p>

            <div className="mt-6 flex flex-wrap items-center justify-center lg:justify-start gap-6">
              {heroStats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-bold text-primary-500 font-heading">
                    {stat.value}
                  </div>
                  <div className="text-xs text-foreground-500 mt-1">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
              <a
                href="#cards"
                onClick={(e) => {
                  e.preventDefault();
                  scrollTo('#cards');
                }}
                className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 font-semibold rounded-md hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer text-base"
              >
                <i className="ri-play-circle-line text-lg"></i>
                开始追剧
              </a>
              <a
                href="#ranking"
                onClick={(e) => {
                  e.preventDefault();
                  scrollTo('#ranking');
                }}
                className="inline-flex items-center gap-2 px-8 py-3 bg-background-100 text-foreground-800 font-medium rounded-md hover:bg-background-200 transition-colors duration-200 whitespace-nowrap cursor-pointer text-base"
              >
                <i className="ri-fire-line text-lg"></i>
                查看热播榜
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-br from-primary-200/30 via-accent-200/20 to-primary-100/30 rounded-2xl blur-xl"></div>
              <div className="relative rounded-xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Cinematic%20film%20projector%20beam%20of%20warm%20golden%20light%20illuminating%20a%20dark%20theater%2C%20floating%20film%20strips%20and%20motion%20picture%20elements%2C%20dramatic%20lighting%20with%20warm%20amber%20and%20crimson%20tones%2C%20artistic%20abstract%20composition%2C%20elegant%20cinema%20aesthetic%2C%20high%20detail%2C%20ethereal%20atmosphere&width=700&height=500&seq=hero-main-visual&orientation=landscape"
                  alt="爱丫爱丫影院 - 电视剧大全全集免费在线观看"
                  className="w-full h-auto object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}